import { Action, ActionReducer, MetaReducer } from '@ngrx/store';
import { AppStateModel } from '@shared/models/app-state.model';
import { logoutAction, resetStoreAction } from '@shared/store/auth/auth.action';

export const resetState = (reducer: ActionReducer<Partial<AppStateModel>>): ActionReducer<Partial<AppStateModel>> => {
  return (state: Partial<AppStateModel>, action: Action): Partial<AppStateModel> => {
    switch (action.type) {
      case logoutAction.type:
      case resetStoreAction.type:
        return reducer({}, action);

      default:
        return reducer(state, action);
    }
  };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const metaReducers: MetaReducer<any>[] = [resetState];
